import type { ComponentType } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { CustomCellDate } from "@/shared/components";
import type { TranslationShowQueryType } from "@/types/graphql/admin.generated";
import { VariantsCell } from "./VariantsCell";

export const TranslationShowComponent: ComponentType<{
  editData?: unknown;
  id?: string;
  translation?: TranslationShowQueryType["translation"];
}> = ({ translation }) => {
  if (!translation) return <div>Загрузка...</div>;

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">
          {`${translation.project}/${translation.namespace}/${translation.version}`}
        </Typography>

        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Версия
          </Typography>
          <Chip
            label={translation.version}
            color={translation.version === "latest" ? "primary" : "default"}
            size="small"
          />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Языки
          </Typography>
          <VariantsCell translation={translation} />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            ID
          </Typography>
          <Typography variant="body1">{translation.id}</Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Создан
          </Typography>
          <CustomCellDate date={translation.createdAt} />
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary">
            Обновлён
          </Typography>
          <CustomCellDate date={translation.updatedAt} />
        </Box>

        {translation.deletedAt ? (
          <Box>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Статус
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Chip label="Удалён" color="warning" size="small" />
              <CustomCellDate date={translation.deletedAt} />
            </Stack>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );
};
